import { useMemo } from 'react';

import { HASURA_ROLE_HEADER } from '~/common/constants';
import { RolesType } from '~/common/types';
import { useAuthRoles } from '~/hooks/useAuthRoles/useAuthRoles';

export const CMDI_NEEDED_ROLES = [RolesType.BuyerAdmin, RolesType.Admin];

export const useCmdiHasuraContext = (): { headers: Record<string, string | undefined> } => {
  const { hasAnyRole } = useAuthRoles();

  return useMemo(
    () => ({
      headers: {
        [HASURA_ROLE_HEADER]: hasAnyRole(CMDI_NEEDED_ROLES),
      },
    }),
    [hasAnyRole],
  );
};
